import React, { useState, useEffect } from "react";
import "../style/ModalDelete.css";

function AutoBidModal({ show, onClose, onConfirm, minBid }) {
  const [value, setValue] = useState(minBid.toString());
  const [error, setError] = useState("");

  // Re-seed the field to the current minimum each time the modal opens (or the
  // minimum changes), otherwise it keeps the value captured at first mount —
  // stale for an upcoming auction whose minimum only resolves after load.
  useEffect(() => {
    if (show) {
      setValue(String(minBid));
      setError("");
    }
  }, [show, minBid]);

  if (!show) return null;

  const handleChange = (e) => {
    const val = e.target.value.replace(/,/g, "");
    if (/^\d*$/.test(val)) {
      setValue(val);
      setError("");
    }
  };

  const formatNumberWithCommas = (number) =>
    number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const confirm = () => {
    const num = parseInt(value || 0, 10);
    // A max bid is a binding commitment the server will act on — never
    // silently substitute a different amount than the user typed.
    if (isNaN(num) || num < minBid) {
      setError(`La oferta máxima debe ser al menos L.${formatNumberWithCommas(minBid)}`);
      return;
    }
    onConfirm(num);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content autobid-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button-left" onClick={onClose} aria-label="Cerrar">✕</button>
        <h2>Oferta máxima</h2>
        <p>El sistema pujará por ti, solo lo necesario, hasta este tope.</p>
        <input
          type="text"
          inputMode="numeric"
          className="autobid-input"
          value={value === "" ? "" : formatNumberWithCommas(parseInt(value, 10))}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && confirm()}
          autoFocus
        />
        {error ? (
          <p className="autobid-error">{error}</p>
        ) : (
          <p className="autobid-min">Mínimo: L.{formatNumberWithCommas(minBid)}</p>
        )}
        <button className="red-button autobid-confirm" onClick={confirm}>Confirmar</button>
      </div>
    </div>
  );
}

export default AutoBidModal;
